const FLOORED = Symbol('FLOORED');
export type Floored = { [key in typeof FLOORED]: never } & number;

const UNIT = {
  NOTHING: '',
  MAN: '万',
  OKU: '億',
  CHOH: '兆',
} as const;
export type Unit = typeof UNIT[keyof typeof UNIT];
const unitToFloorNumberOfDigit = (unit: Unit) => {
  switch (unit) {
    case UNIT.NOTHING:
      return 4 * 0;
    case UNIT.MAN:
      return 4 * 1;
    case UNIT.OKU:
      return 4 * 2;
    case UNIT.CHOH:
      return 4 * 3;
  }
};

export const getUnit = (val: number): Unit => {
  if (val < 10000) return '';
  if (val < 10000 * 10000) return '万';
  if (val < 10000 * 10000 * 10000) return '億';
  return '兆';
};

export const floorByUnit = (
  natural: number,
  unit: Unit,
  numberOfDecimal = 1 // 数値として返すので、1.00のような形では返らない
): Floored => {
  const ret =
    // 小数点以下の情報は残したいかもしれない
    Math.floor(
      (natural * 10 ** numberOfDecimal) / 10 ** unitToFloorNumberOfDigit(unit)
    ) /
    10 ** numberOfDecimal;
  const decimalPart = ret - Math.floor(ret);
  if (decimalPart === 0) return Math.floor(ret) as Floored;
  return ret as Floored;
};

export const unitFormat = (natural_: number, numberOfDecimal = 1) => {
  const natural = Math.abs(natural_);
  const unit = getUnit(natural);
  return `${natural_ >= 0 ? '' : '-'}${floorByUnit(
    natural,
    unit,
    numberOfDecimal
  )}${unit}`;
};
